import Web3 from 'web3';
import { Contract } from 'web3-eth-contract';
import { AbiItem } from 'web3-utils';
import BN from 'bn.js';
import { ContractConfig, CONTRACT_CONFIG, FET_ERC20 } from './constants';

import * as contractABI from "./contract-abi/dutchStaking.json";
import * as tokenContractJSON from "./contract-abi/ERC20TestToken.json";


export class DutchAuction {
    static config: ContractConfig = CONTRACT_CONFIG;
    web3: Web3;
    contract: Contract;
    tokenContract: Contract;

    constructor(web3: Web3) {
        web3.eth.net.getId().then(netId => {
          switch (netId) {
            case 1:
              console.log('Using mainnet')
              break
            case 3:
              console.log('Using the ropsten test network.')
              break
            case 4:
              console.log('Using the rinkeby network.')
              break
            default:
              console.log('Using an unknown network.')
          }
        })
        if (DutchAuction.config.contractAddress.length === 0 || DutchAuction.config.tokenAddress.length === 0) {
            alert("Something is wrong!"); // this can't be reached if website deployed correctly
        }
        this.web3 = web3;
        this.contract = new this.web3.eth.Contract(contractABI.abi as AbiItem[], DutchAuction.config.contractAddress);
        this.tokenContract = new this.web3.eth.Contract(tokenContractJSON.abi as AbiItem[], DutchAuction.config.tokenAddress);
    }

    switchUnit(num: string) {
        let p = new BN(num);
        return p.div(FET_ERC20.multiplier).toNumber();
    }

    switchUnitBN(p: BN) {
        return p.div(FET_ERC20.multiplier).toNumber();
    }

    async getBlockNumber() {
        return await this.web3.eth.getBlockNumber();
    }

    async getBlockTime(bn: number) {
        let block = await this.web3.eth.getBlock(bn);
        return block?.timestamp ?? '';
    }

    async getFinalStakers() {
        let stakers = await this.contract.methods.getFinalStakers().call();
        let map: {[name: string]: number} = {};
        for (let staker of stakers) {
            let stake = await this.contract.methods.getFinalStakerSlots(staker).call();
            map[staker] = stake;
        }
        return map;
    }

    async isFinalized() {
        let r = await this.contract.methods.isFinalised().call();
        return r;
    }

    async getCurrentPrice() {
        let price = new BN(await this.contract.methods.getCurrentPrice().call());
        return price.div(FET_ERC20.multiplier).toNumber();
    }

    async isBiddingPhase() {
        return await this.contract.methods.isBiddingPhase().call();
    }

    async getInfo() {
        return await this.contract.methods.auction().call();
    }

    async getStakers() {
        return await this.contract.methods.getCurrentStakers().call();
    }

    async getLatestPrice() {
        let price = new BN(await this.contract.methods.getLastBidPrice().call());
        return price.div(FET_ERC20.multiplier).toNumber();
    }

    async getDeposits(staker: string) {
        let deposit = new BN(await this.contract.methods.selfStakerDeposits(staker).call());
        return deposit.div(FET_ERC20.multiplier).toNumber();
    }

    async calculateSelfStake(staker: string) {
        let result = new BN(await this.contract.methods.calculateSelfStakeNeeded(staker).call());
        return result.div(FET_ERC20.multiplier).toNumber();
    }

    async didIBid(address: string) {
        let stakers = await this.getStakers();
        address = address.toLowerCase();
        for(let staker of stakers) {
            if (staker.toLowerCase() === address) {
                return true;
            }
            if (staker === "0x0000000000000000000000000000000000000000") {
                break;
            }
        }
        return false;
    }

    async bid(address: string, amount: number): Promise<[boolean, string]> {
        try {
            let bid_amount = new BN(amount).mul(FET_ERC20.multiplier);

            // Check balance is high enough
            let balance = new BN(await this.tokenContract.methods.balanceOf(
                address.toLowerCase()).call());
            if (bid_amount.gt(balance)){
                console.log("Your balance is too low: " + balance.div(FET_ERC20.multiplier).toString())
                return [false, "Your balance is too low: " + balance.div(FET_ERC20.multiplier).toString()];
            }

            // if allowance is not high enough then we need to add another approval
            let allowance = new BN(await this.tokenContract.methods.allowance(address.toLowerCase(),
                DutchAuction.config.contractAddress).call());
            console.log("Allowance", allowance.div(FET_ERC20.multiplier).toString());
            if (bid_amount.gt(allowance)) {
                console.log("APPROVE SPENDING");
                let result = await this.tokenContract.methods.approve(DutchAuction.config.contractAddress,
                    bid_amount).send({from: address.toLowerCase()})
                if (!result.status) {
                    console.log("TOKEN SPEND APPROVE FAILED: ", result);
                    return [false, "Token spend approval failed"];
                }
                console.log("TOKEN SPEND APPROVAL : ", result)
            }

            console.log("BID");
            let result = await this.contract.methods.bid(bid_amount).send({from: address.toLowerCase()});
            console.log("BID DONE: ", result);

        } catch (error) {
            console.log(error);
            return [false, "Bidding failed with error: " + error.message];
        }
        return [true, "Bid was successful"];
    }

    async getStakes() {
        return await this.contract.methods.getFinalStakers().call();        
    }

    async getUniqueStakers() {
        let res = await this.contract.methods.auction__uniqueStakers().call();
        console.log("Stakers: ", res);
        return res;
    }

    async withdrawSelfStake(address: string) {
        return await this.contract.methods.withdrawSelfStake().send({from: address});
    }
}
